<!--
  Preloading strategy:
    - preference for KISSed unique small spinner for breadcrumber only
      rather than preloader placeholders
    - append a slight fade-in cascading effect
-->
<template>
  <layout-teleport-to-breadcrumb>
    <layout-breadcrumb-loader
      :predicate="fetchState.status.value === 'success'"
    />
  </layout-teleport-to-breadcrumb>


  <!-- TAB: Misc leave -->
  <section
    :key="NAV_SECTION.MISC_LEAVE"
    :class="[
      'page-parameters__tab',
      'page-parameters__tab--misc',
    ]"
  >
    <!-- Background -->
    <ui-wad class="overflow-hidden">
      <div class="page-parameters__background" />
    </ui-wad>

    <transition
      v-if="
        fetchState.status.value === 'success' &&
        !(
            hasFeature(FEATURES.FLA_2_AUTRES_ABSENCES) ||
            hasACL(ACLS.OTHER_LEAVE_ENABLED)
         )
      "
      appear
      appear-active-class="animate__animated animate__fadeIn ease-in-out a3"
    >

      <!-- @NOTE: flag placeholder, remove when not needed -->
      <ui-caveat
        variant="light"
        aside-variant="dark"
        size="lg"
        class="animate__animated animate__fadeIn"
      >
        <template #aside>
          <ui-icon
            name="tips_and_updates"
          />
        </template>
        <template #default>
          <ui-wad class="font-family-heading-jumbo font-size-140 color-gray-30 mb-1">
            Paramétrage des autres absences
          </ui-wad>
          <ui-wad class="font-weight-light pb-1">
            Cette page sera bientôt disponible
          </ui-wad>
        </template>
      </ui-caveat>

    </transition>

    <transition
      v-if="
        fetchState.status.value === 'success' &&
        (
          hasFeature(FEATURES.FLA_2_AUTRES_ABSENCES) ||
          hasACL(ACLS.OTHER_LEAVE_ENABLED)
        )
      "
      appear
      appear-active-class="animate__animated animate__fadeIn ease-in-out a2"
    ><div>

      <b-card
        v-if="ccnMode === CCN_MODE.KNOWN_CCN"
        class="page-parameters__ccn-preamble"
      >
        <p class="mb-0.5 font-family-heading color-gray-deep">
          Le code IDCC paramétré dans votre structure est le
          <span class="color-gray-20">{{ ccn.idcc }} &mdash; {{ ccn.full_label || '' }}.</span>
        </p>
        <p class="line-height-1.4 color-gray-dark font-size-90 font-weight-light">
          Voici les motifs d'absences autorisés et les règles applicables selon votre convention collective.
          <br>
          Il vous est possible de personnaliser ce paramétrage&nbsp;:
        </p>

        <preamble-content
          :ccn="ccn"
          :add-leave-type-callback="() => showModal(TRANSAT_PARAMETERS_MISC_LEAVE_CUSTOM_MOTIF_ADD_MODAL)"
          :bulk-update-leave-type-availability-on-transat-callback="bulkUpdateLeaveTypeAvailabilityOnTransatCallback"
        />


      </b-card>

      <b-card
        v-if="ccnMode === CCN_MODE.CODE_TRAVAIL_FALLBACK"
        class="page-parameters__ccn-preamble"
      >
        <p class="font-family-heading color-gray-deep">
          Vous n'avez aucune convention collective paramétrée dans votre structure.
        </p>

        <p class="line-height-1.4 color-gray-dark font-size-90 font-weight-light">
          Voici les motifs d'absences autorisés et les règles applicables selon le <span class="color-gray-20">Code du Travail.</span>
          <!-- <br> -->
          Il vous est possible de personnaliser ce paramétrage&nbsp;:
        </p>

        <preamble-content
          :ccn="ccn"
          :add-leave-type-callback="() => showModal(TRANSAT_PARAMETERS_MISC_LEAVE_CUSTOM_MOTIF_ADD_MODAL)"
          :bulk-update-leave-type-availability-on-transat-callback="bulkUpdateLeaveTypeAvailabilityOnTransatCallback"
        />

      </b-card>

      <b-card
        v-if="ccnMode === CCN_MODE.UNKNOWN_CCN"
        :class="[
          'page-parameters__ccn-preamble',
          'page-parameters__ccn-preamble--warning'
        ]"
      >
        <p class="mb-1 font-family-heading color-gray-deep">
          Le code IDCC paramétré dans votre structure est le <span class="color-gray-20">{{ ccn.idcc }}.</span>
        </p>

        <p class="line-height-1.4 color-gray-dark font-size-90">
          Cette convention collective n'est actuellement <span class="color-gray-20">pas prise en charge</span> par ce module.
          <br>
          Merci de nous contacter
          <ui-link
            :href="MISC_LEAVE_HUBSPOT_FORM_URL"
            target="_blank"
            underline="always"
            class="color-secondary"
          >en cliquant sur ce lien</ui-link>
          pour que nous fassions le nécessaire
        </p>
      </b-card>

    </div></transition>

    <transition
      v-if="
        fetchState.status.value === 'success' &&
        (
          hasFeature(FEATURES.FLA_2_AUTRES_ABSENCES) ||
          hasACL(ACLS.OTHER_LEAVE_ENABLED)
        )
      "
      appear
      appear-active-class="animate__animated animate__fadeIn ease-in-out a2 d1"
    ><div>

      <ui-wad
        v-if="
          !leaveTypeList.length &&
          ccnMode === CCN_MODE.KNOWN_CCN
        "
        class="d-flex justify-content-center"
      >
        <ui-well
          class="page-parameters__nil-caveat"
        >
          Aucun motif n'est actuellement rattaché à la convention collective
        </ui-well>
      </ui-wad>

      <div
        v-for="leaveType in leaveTypeList"
        :key="leaveType.motif_id"
        :data-key="leaveType.motif_id"
        class="page-parameters__leave-type-section"
      >
        <table-section
          v-bind="{
            leaveType,
            ccn,
            deleteLeaveRuleCallback,
            createLeaveRuleCallback,
            editCustomLeaveTypeDetailsCallback,
            deleteLeaveTypeCallback,
            updateLeaveTypeAvailabilityCallback,
          }"
        />
      </div>

    </div></transition>

    <!-- MODAL: add custom motif -->
    <ui-modal
      :id="TRANSAT_PARAMETERS_MISC_LEAVE_CUSTOM_MOTIF_ADD_MODAL"
      title="Ajouter un nouveau motif d'absence"
      no-footer
    >
      <leave-type-create-form
        v-bind="{
          callback: createCustomLeaveTypeCallback,
        }"
      />
    </ui-modal>

  </section>
</template>

<style lang="sass" scoped>
@import '~/assets/sass/modules/layout/variables'
@import '~/assets/sass/modules/transat/variables'

.page-parameters

  &__tab--misc
    position: relative

  &__background
    @include no-interaction
    @include inset
    position: absolute
    background-repeat: repeat
    background-image: image('patterns/dot-grid.png')
    filter: opacity(60%)
    mix-blend-mode: multiply

  ////////////////////////////////////////

  &__ccn-preamble
    // (quick & dirty extrusion)
    $extrude-top: $layout-spacer-y * .5

    margin-top: - $extrude-top
    margin-bottom: $layout-spacer-y
    display: inline-block
    border: 1px solid $tertiary
    font-size: 95%
    width: $misc-leave-row__simulated-width

    &--warning
      border-color: $danger

  ////////////////////////////////////////

  &__nil-caveat
    text-align: center
    padding: ($card-spacer-y * 2) ($card-spacer-x * 2)
    width: map-get($breakpoints, 'mobile')

  ////////////////////////////////////////

  &__leave-type-section

    :deep(.table-section)
      min-width: $misc-leave-row__simulated-width

    &:not(:last-child)
      margin-bottom: $layout-spacer-y * .75

  /// Animation on row deletion
  ///   - impression of the row being discarded out the list
  &__leave-type-section--delete-animation
    transition: all 450ms ease-in-out
    transform: translateX( space-x(2) )
    opacity: 0

</style>

<script lang="ts">
import PreambleContent from '~/components/transat/parameters/leave-type/PreambleContent.vue'
import TableSection from '~/components/transat/parameters/leave-rule/TableSection.vue'
import LeaveTypeCreateForm from '~/components/transat/parameters/leave-type/CreateForm.vue'
import Console from '~/utils/lib/core/console'
import { NAV_SECTION } from '../parameters.vue'
import { clone, concatAll, delay, equals, noop, not, sustainedPromise, tapCatch, tapThen, toString } from '~/utils/lib/core/prelude'
import { useLegacyPageFetch } from '~/composables/core/hook'
import { useToastBuilder } from '~/composables/layout/toast'
import { CODE_TRAVAIL_IDCC, MISC_LEAVE_HUBSPOT_FORM_URL, useStore_transat_parameters_miscLeave, type CCN, type LeaveRule, type LeaveType } from '~/stores/transat/parameters/misc-leave'
import { useLegacyModalController } from '~/composables/layout/modal'
import { FEATURES } from '~/stores/layout/flags'
import { useAccessControl } from '~/composables/layout/access-control'
import { useCompanyRequiredNavigationContext } from '~/composables/layout/navigation'
import { useScroll } from '~/composables/layout/scroll'
import { querySelector } from '~/utils/lib/core/dom'
import { MENU_ITEM, NAVIGATION_SCOPE } from '~/utils/lib/layout/types'
import { useStore_transat_leaveRequest_misc } from '~/stores/transat/leave-request/misc'
import { ACLS } from '@ghsfr/acls-commons'

const console = new Console('component:leave-rule-types')

type CCN_MODE = typeof CCN_MODE[keyof typeof CCN_MODE]
const CCN_MODE = {
  KNOWN_CCN: 'known_ccn',
  UNKNOWN_CCN: 'unknown_ccn',
  CODE_TRAVAIL_FALLBACK: 'code_travail_fallback',
}

const TRANSAT_PARAMETERS_MISC_LEAVE_CUSTOM_MOTIF_ADD_MODAL = 'transat_parameters_misc_leave_custom_motif_add_modal'

export default defineNuxtComponent({
  components: { TableSection, LeaveTypeCreateForm, PreambleContent },
  setup() {
    definePageMeta({
      navigationScope: NAVIGATION_SCOPE.COMPANY_REQUIRED,
      menuItem: MENU_ITEM.ABSENCES,
    })
    const navigationContext = useCompanyRequiredNavigationContext()

    const {
      fetchState,
      fetchWrapper,
    } = useLegacyPageFetch()

    const ToastBuilder = useToastBuilder()

    const setNavSection = inject<((_: NAV_SECTION) => void)>('setNavSection', noop)

    setNavSection(NAV_SECTION.MISC_LEAVE)

    const {
      showModal,
      hideModal,
    } = useLegacyModalController()

    const {
      scrollTo,
    } = useScroll()

    const store_parameters_miscLeave = useStore_transat_parameters_miscLeave()
    const store_leaveRequest_misc = useStore_transat_leaveRequest_misc()

    return {
      ...navigationContext,
      fetchState,
      fetchWrapper,
      ToastBuilder,
      showModal,
      hideModal,
      ...useAccessControl(),
      scrollTo,
      store_parameters_miscLeave,
      store_leaveRequest_misc,
    }
  },
  data() {
    return {
      TRANSAT_PARAMETERS_MISC_LEAVE_CUSTOM_MOTIF_ADD_MODAL,
      MISC_LEAVE_HUBSPOT_FORM_URL,
      CCN_MODE,
      NAV_SECTION,
      ccnMode: ('' as CCN_MODE), // lazy
      ccn: (null as unknown as CCN), // lazy
      leaveTypeList: ([] as LeaveType[]), // lazy
    }
  },
  created() {
    this.fetchWrapper(
      () => {
        const hasMiscLeaveAccess
           = this.hasFeature(FEATURES.FLA_2_AUTRES_ABSENCES)
          || this.hasACL(ACLS.OTHER_LEAVE_ENABLED)

        if (not(hasMiscLeaveAccess))
          return Promise.resolve()

        return this.refreshData()
      }
    )
  },
  methods: {
    refreshData() {
      const {
        structure: { uuidData },
        company: { code_societe },
      } = this.fromCompanyLevel()

      const options = {
        uuidData,
        code_societe,
      }

      return this.store_parameters_miscLeave.ccnWithLeaveRuleList(options)
        .then(results => {
          this.ccn = clone(results.ccn_details)
          this.ccnMode = getCCNMode(results.ccn_details)
          this.leaveTypeList = clone(results.leave_type_list)

          this.store_leaveRequest_misc.resetMemoizedFlag()
        })
        .catch(tapCatch(err => {
          console.warn('fetch', err)
          this.ToastBuilder
            .error(toString(err))
            .title(`Récupération des données "Autres absences"`)
            .show()
        }))
    },
    createLeaveRuleCallback(
      { motif_id, data }
      :{ motif_id :LeaveType["motif_id"], data: any }
    ) {
      const {
        structure: { uuidData },
        company: { code_societe },
      } = this.fromCompanyLevel()

      return sustainedPromise(
          300,
          this.store_parameters_miscLeave.addLeaveRule(
            { uuidData, code_societe, motif_id, data }
          ),
        )
        .then(() => this.refreshData())
        .then(() => {
          this.ToastBuilder
            .success()
            .title(`Nouvelle règle ajoutée`)
            .show()
        })
        .catch(tapCatch(err => {
          console.warn('createLeaveRuleCallback', err)
          this.ToastBuilder
            .error(toString(err))
            .title(`Ajout d'une nouvelle règle`)
            .show()
        }))
    },
    deleteLeaveRuleCallback(
      motif_id :LeaveType["motif_id"],
      rule_id :LeaveRule["rule_id"],
    ) {
      const {
        structure: { uuidData },
        company: { code_societe }
      } = this.fromCompanyLevel()

      return this.store_parameters_miscLeave.deleteLeaveRule(
          { uuidData, code_societe, rule_id, motif_id }
        )
        .then(() => {
          // (assuming row deletion animation, detached)
          delay(450).then(() => this.refreshData())
        })
        .catch(tapCatch(err => {
          console.warn('deleteLeaveRuleCallback', err)
          this.ToastBuilder
            .error(toString(err))
            .title(`Suppression d'une règle`)
            .show()
        }))
    },
    createCustomLeaveTypeCallback(
      data :Pick<LeaveType, "comment"|"label">
    ) {
      const {
        structure: { uuidData },
        company: { code_societe }
      } = this.fromCompanyLevel()

      return sustainedPromise<LeaveType["motif_id"]>(
          300,
          this.store_parameters_miscLeave.addCustomLeaveType(
            { uuidData, code_societe, data }
          )
        )
        .then(tapThen(() => this.refreshData()))
        .then(motif_id => {
          this.hideModal(TRANSAT_PARAMETERS_MISC_LEAVE_CUSTOM_MOTIF_ADD_MODAL)

          // slight delay before scrolling to newly item to prevent overload
          // stilumation
          delay(400)
            .then(() => {
              const query = concatAll([
                `.page-parameters`,
                `__leave-type-section`,
                `[data-key="${motif_id}"]`
              ])

              this.scrollTo(query, { offset: -16 }) // (minus empirical gap)

              this.ToastBuilder
                .success()
                .title(`Nouveau motif d'absence ajouté`)
                .show()
            })
        })
        .catch(tapCatch(err => {
          console.warn('createCustomLeaveTypeCallback')
          this.ToastBuilder
            .error(toString(err))
            .title(`Ajout d'un nouveau motif d'absence`)
            .show()
        }))
    },
    editCustomLeaveTypeDetailsCallback(
      motif_id :LeaveType["motif_id"],
      data :Pick<LeaveType, "comment"|"label">
    ) {
      const {
        structure: { uuidData },
        company: { code_societe }
      } = this.fromCompanyLevel()

      return sustainedPromise(
          300,
          this.store_parameters_miscLeave.updateCustomLeaveTypeDetails(
            { uuidData, code_societe, motif_id, data }
          )
        )
        .then(() => this.refreshData())
        .then(() => {
          this.ToastBuilder
            .success()
            .title(`Motif d'absence modifié`)
            .show()
        })
        .catch(tapCatch(err => {
          console.warn('editCustomLeaveTypeDetailsCallback')
          this.ToastBuilder
            .error(toString(err))
            .title(`Modification du motif d'absence`)
            .show()
        }))
    },
    deleteLeaveTypeCallback(
      motif_id :LeaveType["motif_id"],
    ) {
      const {
        structure: { uuidData },
        company: { code_societe }
      } = this.fromCompanyLevel()

      return sustainedPromise(
          300,
          this.store_parameters_miscLeave.deleteCustomLeaveType(
            { uuidData, code_societe, motif_id }
          )
        )
        .then(() => removeLeaveType(motif_id))
        // (following deletion animation, empirical delay before list refreshing)
        .then(() => delay(100))
        .then(() => this.refreshData())
        .catch(tapCatch(err => {
          console.warn('deleteLeaveTypeCallback')
          this.ToastBuilder
            .error(toString(err))
            .title(`Suppression d'un motif d'absence`)
            .show()
        }))
    },
    updateLeaveTypeAvailabilityCallback(
      motif_id :LeaveType["motif_id"],
      data :Pick<LeaveType, "is_on_hamac"|"is_on_transat">
    ) {
      const {
        structure: { uuidData },
        company: { code_societe }
      } = this.fromCompanyLevel()

      return sustainedPromise(
          300,
          this.store_parameters_miscLeave.updateLeaveTypeAvailability(
            { uuidData, code_societe, motif_id, data }
          )
        )
        .then(() => this.refreshData())
        .catch(tapCatch(err => {
          console.warn('updateLeaveTypeAvailabilityCallback')
          this.ToastBuilder
            .error(toString(err))
            .title(`Modification du motif d'absence`)
            .show()
        }))
    },
    bulkUpdateLeaveTypeAvailabilityOnTransatCallback() {
      const {
        structure: { uuidData },
        company: { code_societe }
      } = this.fromCompanyLevel()

      const data = {
        is_on_transat: true
      }

      return sustainedPromise(
          300,
          this.store_parameters_miscLeave.bulkUpdateLeaveTypeAvailabilityOnTransat(
            { uuidData, code_societe, data }
          )
        )
        .then(() => this.refreshData())
        .then(() => {
          this.ToastBuilder
            .success()
            .title(`Tous les motifs sont désormais disponibles sur Transat`)
            .show()
        })
        .catch(tapCatch(err => {
          console.warn('bulkUpdateLeaveTypeAvailabilityOnTransatCallback')
          this.ToastBuilder
            .error(toString(err))
            .title(`Activation des motifs d'absence sur Transat`)
            .show()
        }))
    },
  }
})

function getCCNMode(ccn :CCN) :CCN_MODE {
  switch (true) {

    case equals(ccn.idcc, CODE_TRAVAIL_IDCC):
      return CCN_MODE.CODE_TRAVAIL_FALLBACK

    case ccn.ccn_exists:
      return CCN_MODE.KNOWN_CCN

    default:
      return CCN_MODE.UNKNOWN_CCN
  }
}

function removeLeaveType(motif_id :LeaveType["motif_id"]) {
  const query = concatAll([
    `.page-parameters`,
    `__leave-type-section`,
    `[data-key="${motif_id}"]`
  ])

  const className = concatAll([
    `page-parameters`,
    '__leave-type-section',
    `--delete-animation`
  ])

  querySelector(query)
    .map(element => element.classList.add(className))
}
</script>
